// extracted by mini-css-extract-plugin
export var closeIcon = "styles-module--closeIcon--6cc54";
export var white = "styles-module--white--2f83d";